module.exports = __webpack_public_path__ + "static/media/SheJiao5.ecb3063e.png";